import { useTruncationDetection } from "../hooks/useTruncationDetection";
import * as styles from "../styles";
import { Box, Tooltip } from "@mui/material";
import React from "react";
import { useEffect, useRef } from "react";

const DEFAULT_TOOLTIP_DELAY = 500;
const TruncatedText = ({
  children,
  tooltipDelay = DEFAULT_TOOLTIP_DELAY,
  sx,
  component = "span",
  onTruncationChange,
}) => {
  const [ref, isTruncated] = useTruncationDetection();

  const onTruncationChangeRef = useRef(onTruncationChange);
  onTruncationChangeRef.current = onTruncationChange;

  useEffect(() => {
    onTruncationChangeRef.current?.(isTruncated);
  }, [isTruncated]);
  const content = (
    <Box
      component={component}
      ref={ref}
      sx={{ display: "block", ...styles.truncatedText, ...sx }}
    >
      {children}
    </Box>
  );
  if (isTruncated) {
    return (
      <Tooltip
        title={children}
        enterDelay={tooltipDelay}
        enterNextDelay={tooltipDelay}
      >
        {content}
      </Tooltip>
    );
  }
  return content;
};
export default TruncatedText;
